module.exports = __webpack_public_path__ + "media/images/display/blur-d6e201c9183ee851fb8bda6f8258bccf.png";